import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import LoginSlice from './slices/LoginSlice';
import LoadAIAgentsSlice from './slices/LoadAIAgentsSlice';
import ActiveSystemAiAgentLists from './slices/ActiveSystemAiAgentLists';
import SystemAiAgentProfile from './slices/SystemAiAgentProfile';
import CreateAgentSlice from './slices/CreateAgentSlice';
import ProfileSlice from '../redux/slices/ProfileSlice'
import DeploySlice from '../redux/slices/DeployAIAgent'
import StatusProgressSlice from '../redux/slices/StatusProgressSlice'
import StatisticsSlice from '../redux/slices/StatisticsSlice'
import PdfDataSlice from '../redux/slices/PdfSlice'
import CSVDataSlice from '../redux/slices/CSVDataSlice';
import AgentImageSlice from '../redux/slices/AgentImageSlice';

const loginPersistConfig = {
  key: 'LoginSlice',
  storage,
  whitelist: ['user', 'token'],
};

// Combine your reducers
const appReducer = combineReducers({
  LoginSlice: persistReducer(loginPersistConfig, LoginSlice),
  LoadAIAgentsSlice,
  ActiveSystemAiAgentLists,
  SystemAiAgentProfile,
  CreateAgentSlice,
  ProfileSlice,
  DeploySlice,
  StatusProgressSlice,
  StatisticsSlice,
  PdfDataSlice,
  CSVDataSlice,
  AgentImageSlice
});

// Root reducer to handle logout and clear state
const rootReducer = (state, action) => {
  if (action.type === "auth/clearState") {
    // Reset state by passing `undefined` to `appReducer`
    storage.removeItem('persist:root'); // Clear persisted state
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

// Configuration for redux-persist
const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['CreateAgentSlice', 'ProfileSlice', 'CSVDataSlice', 'AgentImageSlice'], // Specify which reducers to persist
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Create a persistor
const persistor = persistStore(store);

export { store, persistor };
